export default defineNuxtRouteMiddleware((to, from) => {
  const localePath = useLocalePath()
  const account = useAccountStore()
  const app = useNuxtApp()
  let loginUrl = '/login'
  if (!app.$config.public.auth0ClientId) {
    loginUrl = '/admin/login'
  }

  if (!to.path.includes('/login') && !account.isAuthenticated) {
    return navigateTo(
      localePath({ path: loginUrl, query: { next: to.fullPath } }),
      { replace: true }
    )
  }
})
